<div class="search-wrapper primary-btn-bg">
  <div class="input-pill">
    <!-- search icon -->
    <span class="icon left" aria-hidden="true">
      <!-- magnifier SVG -->
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M21 21l-4.35-4.35" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        <circle cx="11" cy="11" r="6" stroke="currentColor" stroke-width="2" fill="none" />
      </svg>
    </span>

    <input #searchItem id="itemId" type="text" [(ngModel)]="itemId" [placeholder]="placeHolder" autofocus
      (keyup.enter)="onClick()" />

      @if (itemId) {
        <button type="button" class="clear-btn" aria-label="Clear search" (click)="onClose()">
          <!-- X svg -->
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
      }
    </div>

    <button pButton label="Search" class="p-3 px-4 border-round-2xl" (click)="onClick()"></button>
  </div>


  @if (isNotFound) {
    <div class="grid">
      <div class="col-12 mt-8 text-center">
        <strong style="margin-left: 5px;">Item not found, Please try again.</strong>
      </div>
    </div>
  }